import { CashAppPayStatus } from '@afterpay/types'
import { IconSizes, PaymentIcon, Text } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'
import { PaymentMethod } from './PaymentMethod'
import { useTranslation } from '../../utils/convergence'
import { PaymentMethodInfo } from './PaymentMethodInfo'
import styles from './style.module.css'

interface Props {
  cashtag: string
  status: CashAppPayStatus
  iconSize?: IconSizes
  testNameSpace?: string
  validatePaymentType?: boolean
  disabled?: boolean
}

export const CashAppPayment: FunctionComponent<Props> = ({ iconSize, cashtag, status, validatePaymentType = false, disabled = false, ...props }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.cashAppPaymentContainer}>
      <PaymentMethod
        icon={<PaymentIcon.CashPay size={iconSize} title={t('paymentMethod:cashAppPay')} />}
        paymentMethodName={t('paymentMethod:cashAppPay')}
        paymentMethodInfo={<PaymentMethodInfo cashTag={cashtag} />}
        disabled={disabled}
        {...props}
      />
      {status !== 'REVOKED' && (
        <Text size='XS' color='Subtle' testNameSpace='cashapp-payment-method-disclaimer'>
          {t('paymentMethod:cashAppPaymentMethodDisclaimer')}
        </Text>
      )}
    </div>
  )
}
